// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './assets/css/animate.min.css';
import './assets/css/style.css';
import store from './store/'
import "babel-polyfill"
import PlugIn from '@/lib/utils/'
import Qs from 'qs'
Vue.use(PlugIn)
Vue.use(iView);
Vue.prototype.$qs = Qs 
Vue.prototype.handleReset = function (name) 
{
    this.$refs[name].resetFields();
}
Vue.prototype.loadings = function(str)
{
    let conso = str ? str : '数据提交中，请稍后...';
    this.$Spin.show({
        render: (h) => {
            return h('div', [
                h('Icon', {
                    'class': 'demo-spin-icon-load',
                    props: {
                        type: 'ios-loading',
                        size: 18
                    }
                }),
                h('div',{
                    'class': 'loadingColor',
                },conso)
            ])
        }
    });
}
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {

    // config.getLoginInfoRole().role[0]
    if(localStorage.Token)
    {
      
      if (!store.state.permission.permissionList) {
        store.dispatch('FETCH_PERMISSION').then(() => {
          if(to.path === '/'||to.path === '/gradeLogin')
          {
            
            if(localStorage.authorities.indexOf('ROLE_AWARD_ADMIN')!=-1)
            {
                next({
                    path: '/List', 
                });
            
            }else{
                next({
                    path: '/sportermeeting', 
                });
            }
          }else{
            next({ path: to.fullPath });
          }
          
        })
      }else 
      {
        
          if (to.path !== '/gradeLogin') {
              next()
          } else {
              next(from.fullPath)
          }
      }
    }else
    {
      if ( 
        to.matched.length > 0 &&
        !to.matched.some(record => record.meta.requiresAuth)
       ) 
      {
          next()
      } else {
        
          next({ path: '/gradeLogin' });
      }
    }
  })
  router.afterEach((to, from) => {
    // 进入路由更改页面title标题
    if(to.meta.parentRouter || to.meta.childRouter)
    {
      setTimeout(()=>{
        router.app.$store.commit('getRouterTitle',to.meta);
        console.log(to.meta)
      },100);
      
    }
    
  })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js